import { transformDTODate } from "@skylab-shared/core";
import { Transform } from 'class-transformer';

export class SaleDocumentAdditionalDataDTO {
    public orderNumber?: string;
    @Transform(transformDTODate, { toClassOnly: true }) public orderDate?: Date | null;
    public agreementNumber?: string;
    @Transform(transformDTODate, { toClassOnly: true }) public agreementDate?: Date | null;
}